module.exports = __webpack_public_path__ + "img/search.9d670bc9.svg";